import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useRouter } from '@tanstack/react-router'
import { createLoginSchema } from './auth.schema'
import type { LoginFormValues } from './auth.schema'

export function useLoginForm() {
  const { t } = useTranslation()
  const router = useRouter()
  const form = useForm<LoginFormValues>({
    resolver: zodResolver(createLoginSchema(t)),
    defaultValues: {
      email: '',
      password: '',
    },
    mode: 'onSubmit',
  })

  const onSubmit = form.handleSubmit(async () => {
    // API integration will be connected later.
    router.navigate({ to: '/' })
  })

  return { form, onSubmit }
}
